export const escapeHtml = (unsafe = '') => {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

export const afterSanitizeAttributes = currentNode => {
  if ('target' in currentNode) {
    currentNode.setAttribute('target', '_blank');
  }
};

// [UPSTREAM-ADAPT 4218dc6793] Espelha a lista de URI seguras do DOMPurify e acrescenta o protocolo
// interno das ferramentas do Captain (tool://), usado so pela configuracao nomeada `toolLinks`.
const DOMPURIFY_SAFE_URI_PATTERN =
  '(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|' +
  '[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))';
const TOOL_LINK_URI_PATTERN = new RegExp(
  `^(?:tool://|${DOMPURIFY_SAFE_URI_PATTERN})`,
  'i'
);

export const domPurifyConfig = {
  hooks: {
    afterSanitizeAttributes,
  },
  namedConfigurations: {
    toolLinks: {
      ALLOWED_URI_REGEXP: TOOL_LINK_URI_PATTERN,
    },
  },
};
